import React from 'react';
import {BsLinkedin} from 'react-icons/bs';
import {FiGithub} from 'react-icons/fi';
import {ImInstagram} from 'react-icons/im';
import {FiGitlab} from 'react-icons/fi';

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
    <a href='https://github.com/LuckYYadav15' target="_blank"><FiGithub/></a>
    <a href='https://gitlab.com/LuckYYadav15' target="_blank"><FiGitlab/></a>
    <a href='https://www.instagram.com/utkarshyadav15/' target="_blank"><ImInstagram/></a>
    <a href='https://www.linkedin.com/in/lucky-yadav-19b403232/' target="_blank"><BsLinkedin/></a>

    </div>
  )
}

export default HeaderSocials;